import { ReactComponent as Logo } from "../assets/logo.svg";

export default Logo;
